import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { WindowContext } from '@components/windowContextProvider'
import 'material-icons/iconfont/outlined.css'

import LoanFilterModal from '@components/modal/loanFilterModal'

import {
  Container,
  SearchContainer,
  FeatureContainer,
  SearchIcon,
  TuneIcon,
  Button,
  Input,
  Row,
  InputContainer
} from './styles'

const LoanFilter = ({
  selectAllState,
  setFilterState,
  searchTerm,
  onSearch,
  onInputChange,
  isOpen
}) => {
  const [loanModal, setLoanModal] = useState(false)

  const { clientWidth } = useContext(WindowContext)

  const selectAllBreak = clientWidth <= 845

  const inputBreak = clientWidth <= 490

  const inputPlaceHolderBreak = clientWidth <= 390

  const renderFeatures = (
    <FeatureContainer>
      <Button
        onClick={() => setLoanModal(true)}
      >
        <TuneIcon className="material-icons-outlined" state={selectAllState}>tune</TuneIcon>
      </Button>

    </FeatureContainer>
  )

  return (
    <Container state={selectAllState}>
      <Row>
        {!selectAllBreak}
        <SearchContainer>
          <InputContainer>
            <Input
              placeholder="Digite o nome do beneficiário ou equipamento"
              value={searchTerm}
              style={{
                fontSize: inputPlaceHolderBreak ? 12 : 14
              }}
              onChange={(e) => onInputChange(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            />
            <SearchIcon onClick={() => onSearch()} className="material-icons-outlined" state={selectAllState}>search</SearchIcon>
          </InputContainer>
        </SearchContainer>

        {!inputBreak && renderFeatures}

        <LoanFilterModal
          setFilterState={setFilterState}
          isOpen={loanModal}
          setClose={() => setLoanModal(false)}
          isOpenLoans={isOpen}
        />
      </Row>
    </Container>
  )
}

LoanFilter.propTypes = {
  selectAllState: PropTypes.bool,
  searchTerm: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  setFilterState: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
}

LoanFilter.defaultProps = {
  selectAllState: false,
  searchTerm: '',
  isOpen: false,
}

export default LoanFilter
